<template>
	<div id="root-app">
		<div style="margin-top: 25px;"></div>
		<div id="player" class="row">
			<iframe
				id="player-frame"
				class="col-9"
				:src="activeSrc"
				frameborder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>

			<div id="player-list" class="col-3">
				<h5><b>Titles</b></h5>
				<button
					class="player-list-entry btn btn-primary"
					v-for="title in titles"
					:key="title.id"
					v-on:click="play(title.id)"
				>
					{{ title.name }}
					<div class="title-by">{{ title.by }}</div>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Root.vue',
	data: function() {
		return {
			activeTitle: null,
			activeSrc: '',
			titles: [
				{ name: 'Be Somebody', by: 'Medii', id: 'MJcJ553VVBo' },
				{ name: 'Tears In Your Eyes', by: 'Nora En Pure', id: 'lnnP90nSJfY' },
				{ name: 'Something', by: 'AZEDIA', id: 'UXH3YKOUeC8' },
				{ name: 'Versailles', by: 'Axollo', id: 'Wf7cEno9pRM' },
				{
					name: 'No Control',
					by: 'Fragile, KroWeZ & Hexa',
					id: 'uTarsyxZ878?start=996'
				},
				{ name: 'To The Top', by: 'Gentleman', id: '_5nSn40Jtu8?start=37' },
				{ name: 'Nobody Else', by: 'Gamper & Dadoni', id: 'rPR2IAt-F4I' },
				{ name: '前前前世', by: 'radwimps', id: 'PDSkFeMVNFs' },
				{ name: 'Radio', by: 'Rammstein', id: 'z0NfI2NeDHI' }
			]
		};
	},
	methods: {
		play: function(id) {
			this.activeSrc =
				'https://www.youtube.com/embed/' +
				id +
				(id.includes('?') ? '&' : '?') +
				'autoplay=1';
		}
	},
	mounted: function() {
		this.play(this.titles[0].id);
	}
};
</script>

<style scoped>
#root-app {
	margin-top: 100px;
}
#player {
	min-height: 500px;
	height: 100%;
	max-width: 960px;
	padding: 20px;
	margin: 0 auto;
	background-color: #272727;
	border: 1px solid black;
}
#playlists {
	margin-bottom: 20px;
}
.player-list-entry {
	width: 100%;
	margin-bottom: 3px;
}
.title-by {
	font-size: 10px;
	color: #888888;
}
</style>
